export default "__VITE_ASSET__DJPA3ntz__"